

import { VideoIcon } from 'lucide-react';

export const EmptyVideosList: React.FC = () => {
  return (
    <div className="text-center py-8">
      <VideoIcon className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
      <h3 className="text-lg font-medium mb-2">No videos yet</h3>
      <p className="text-muted-foreground mb-4">
        Add YouTube videos to help you learn and practice this technique.
      </p>
    </div>
  );
};
